import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Toaster } from '@notino/react-styleguide';

import { useWishlistActionsFactory } from '@components/Universals/WishlistModifier/useWishlistActions';
import { useListsData } from '@containers/WishlistLists/hooks/useListsData';
import { commonMessages } from '@lib/commonMessages';
import { styled } from '@linaria/react';

import messages from '../../../components/Universals/WishlistModifier/messages';
import { useWishlistStore, WishlistStoreProduct } from '../store';

const UndoButton = styled.button`
  all: unset;
  cursor: pointer;
  text-decoration: underline;
  align-self: stretch;
`;

export const useRemoveFromWishlistUndoNotification = () => {
  const { lists } = useListsData();
  const { handleWishlistClick } = useWishlistActionsFactory({});
  const { insertFirstProduct } = useWishlistStore((state) => state.actions);

  const notifyProductRemoved = ({
    product,
    listId,
  }: {
    product: WishlistStoreProduct;
    listId: string;
  }) => {
    const list = lists.find((l) => l.id === listId);
    if (!product || !list) {
      return;
    }

    let undone = false;
    const undo = async () => {
      if (undone) return;
      undone = true;
      await handleWishlistClick({
        lists,
        addToLists: [{ id: listId }],
        removeFromLists: [],
        productIds: [product.id ?? ''],
        actionLocation: 'wishlist',
        doNotTrack: true,
      });
      insertFirstProduct(product);
    };

    Toaster.info({
      icon: 'IconRegularCheckmark',
      content: (
        <FormattedMessage
          {...messages.productRemovedFromList}
          values={{
            product: `${product.brand?.name ?? ''} ${product.name ?? ''}`,
            list: list.name,
            b: (chunks: React.ReactNode) => (
              <b style={{ fontWeight: 500 }}>{chunks}</b>
            ),
          }}
        />
      ),
      button: (
        <UndoButton onClick={undo}>
          <FormattedMessage {...commonMessages.undo} />
        </UndoButton>
      ),
    });
  };

  return { notifyProductRemoved };
};
